import {isEqual, isNull} from "lodash/lang"
import {findIndex, indexOf} from "lodash/array"
import {find} from "lodash/collection"
import {createProject, deleteProject, listProject, updateProject} from "../../api/api-project"
import {apiAuth} from "../../main"
import {promiseWrapper} from "../../helpers/utils"

const defaultState = () => ({
  projectList: null,
})
const state = defaultState()

// -------------- Mutations -------------- //
const MUTATIONS_TYPES = {
  // List
  SET_PROJECT_LIST: "SET_PROJECT_LIST",

  // CRUD
  CREATE_PROJECT: "CREATE_PROJECT",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  DELETE_PROJECT: "DELETE_PROJECT",

  CLEAN_PROJECT: "CLEAN_CURRENT_PROCESSING",
}
const mutations = {
  [MUTATIONS_TYPES.SET_PROJECT_LIST](state, projectList) {
    state.projectList = projectList
  },
  [MUTATIONS_TYPES.CREATE_PROJECT](state, projectData) {
    state.projectList.push(projectData)
  },
  [MUTATIONS_TYPES.UPDATE_PROJECT](state, projectData) {
    if (!isNull(state.projectList)) {
      const idxProject = findIndex(state.projectList, value => isEqual(value["id_project"], projectData["id_project"]))
      state.projectList.splice(idxProject, 1, projectData)
    }
  },
  [MUTATIONS_TYPES.DELETE_PROJECT](state, projectData) {
    if (!isNull(state.projectList)) {
      const project = find(
        state.projectList,
        ["id_project", projectData["id_project"]],
      )
      const idxOfProject = indexOf(
        state.projectList,
        project,
      )
      state.projectList.splice(idxOfProject, 1)
    }
  },
  [MUTATIONS_TYPES.CLEAN_PROJECT](state) {
    Object.assign(state, defaultState())
  },
}

// -------------- Getters -------------- //
export const GET_PROJECT_LIST = "GET_PROJECT_LIST"
const getters = {
  [GET_PROJECT_LIST](state) {
    return state.projectList
  },
}

// -------------- Actions -------------- //
//API Actions
export const LIST_PROJECT = "LIST_PROJECT"
export const CREATE_PROJECT = "CREATE_PROJECT"
export const UPDATE_PROJECT = "UPDATE_PROJECT"
export const DELETE_PROJECT = "DELETE_PROJECT"
export const CLEAN_PROJECT = "CLEAN_PROJECT"
const actions = {
  [LIST_PROJECT]({commit}) {
    return promiseWrapper(listProject(apiAuth.getAuthToken()),
      res => {
        commit(MUTATIONS_TYPES.SET_PROJECT_LIST, res.data.data)
      }, () => {
      },
    )
  },
  [CREATE_PROJECT]({commit}, projectData) {
    return promiseWrapper(createProject(apiAuth.getAuthToken(), projectData),
      res => {
        commit(MUTATIONS_TYPES.CREATE_PROJECT, res.data.data)
      }, () => {
      },
    )
  },
  [UPDATE_PROJECT]({commit}, {idProject, projectData}) {
    return promiseWrapper(updateProject(apiAuth.getAuthToken(), idProject, projectData),
      res => {
        commit(MUTATIONS_TYPES.UPDATE_PROJECT, res.data.data)
      },
      () => {
      },
    )
  },
  [DELETE_PROJECT]({commit}, idProject) {
    return promiseWrapper(deleteProject(apiAuth.getAuthToken(), idProject),
      res => {
        commit(MUTATIONS_TYPES.DELETE_PROJECT, res.data.data)
      },
      () => {
      },
    )
  },
  [CLEAN_PROJECT]({commit}) {
    commit(MUTATIONS_TYPES.CLEAN_PROJECT)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
